<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-right mt-1">
      <label>File name</label>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.vlbi_file_name" class="file_name_input"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <NameResolver fields-prefix="vlbi" />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ToggleAllButton fields-prefix="vlbi" />
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <b-form-checkbox v-model="fields.vlbi_dateobs_sel" :disabled="toggleStatus" class="mt-1">Obs date</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.vlbi_dateobs_min" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.vlbi_dateobs_min" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.vlbi_dateobs_min">{{fieldErrors.vlbi_dateobs_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.vlbi_dateobs_max" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.vlbi_dateobs_max" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.vlbi_dateobs_max">{{fieldErrors.vlbi_dateobs_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <b-form-checkbox v-model="fields.vlbi_freq_sel" :disabled="toggleStatus" class="mt-1">Frequency [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_min_freq_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_min_freq_min">{{fieldErrors.vlbi_min_freq_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_max_freq_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_max_freq_max">{{fieldErrors.vlbi_max_freq_max}}</span>
    </div>
  </div>
  
  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.vlbi_program_sel" :disabled="toggleStatus" class="mt-1">Project id</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_program"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.vlbi_antennas_sel" :disabled="toggleStatus" class="mt-1">Telescopes</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.vlbi_antennas" multiple class="w-100">
        <option value="Nt">Noto</option>
        <option value="Mc">Medicina</option>
        <option value="Sr">SRT</option>
      </b-form-select>
    </div>
    <div class="col-6">
      <b-form-radio-group label="Mode" v-model="fields.vlbi_antennas_query_mode" v-slot="{ ariaAntennasMode }" class="mt-3">
        <b-form-radio :aria-describedby="ariaAntennasMode" name="antennas_query_mode" value="AND">AND</b-form-radio>
        <b-form-radio :aria-describedby="ariaAntennasMode" name="antennas_query_mode" value="OR">OR</b-form-radio>
      </b-form-radio-group>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox v-model="fields.vlbi_rate_sel" :disabled="toggleStatus" class="mt-1">Data rate [Mbit/s]</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_rate"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.vlbi_channels_sel">Spectral channels</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_channels"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.vlbi_ch_resol_sel" class="mt-1">Spectral resolution [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_ch_resol_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_ch_resol_min">{{fieldErrors.vlbi_ch_resol_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_ch_resol_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_ch_resol_max">{{fieldErrors.vlbi_ch_resol_max}}</span>
    </div>
  </div>

<!--
  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.vlbi_bandwid_sel" class="mt-1">Bandwidth [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_bandwid_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_bandwid_min">{{fieldErrors.vlbi_bandwid_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_bandwid_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_bandwid_max">{{fieldErrors.vlbi_bandwid_max}}</span>
    </div>
  </div>
  -->
  
  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.vlbi_ontime_sel" class="mt-1">Observation duration [s]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_ontime_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_ontime_min">{{fieldErrors.vlbi_ontime_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.vlbi_ontime_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.vlbi_ontime_max">{{fieldErrors.vlbi_ontime_max}}</span>
    </div>
  </div>
</div>
</template>

<script>
import NameResolver from './RadioNameResolver.vue';
import ToggleAllButton from './ToggleAllButton.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'VLBI',
  components: {
    NameResolver,
    ToggleAllButton
  },
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors,
    toggleStatus: state => state.searchForm.toggleStatus['vlbi']
  })
}
</script>
